import { useEffect, useLayoutEffect, useState } from 'react';
import WebHelper from './WebHelper';
import moment from 'moment';
import 'moment/locale/pl';
import Calendar from './Calendar';
import { FaArrowRight, FaArrowLeft } from 'react-icons/fa';

import { Slide } from 'react-slideshow-image';
import 'react-slideshow-image/dist/styles.css'

const searchParams = new URLSearchParams(window.location.search);

function App() {
  const [selectedOverSeerGroup, setSelectedOverSeerGroup] = useState(undefined);
  const [selectedOverSeer, setSelectedOverSeer] = useState(searchParams.get("id"));
  const [workHours, setWorkHours] = useState(undefined);
  const [overSeers, setOverSeers] = useState(undefined);
  const [overSeerGroups, setOverSeerGroups] = useState({});
  const [exceptions, setExceptions] = useState(undefined);
  const [reservations, setReservations] = useState(undefined);
  const [error, setError] = useState(undefined);

  const [selectedDate, setSelectedDate] = useState(undefined);
  const [selectedTime, setSelectedTime] = useState(undefined);

  const [name, setName] = useState(undefined);
  const [description, setDescription] = useState(undefined);
  const [calendars, setCalendars] = useState([]);
  const [phoneNumber, setPhoneNumber] = useState(undefined);
  const [email, setEmail] = useState(undefined);

  const [validObj, setValidObj] = useState({
    selectedOverSeer: true,
    selectedDate: true,
    selectedTime: true,
    name: true,
    telNumber: true,
    email: true
  });

  function useWindowSize() {
    const [size, setSize] = useState([0, 0]);
    useLayoutEffect(() => {
      function updateSize() {
        setSize([window.innerWidth, window.innerHeight]);
      }
      window.addEventListener('resize', updateSize);
      updateSize();
      return () => window.removeEventListener('resize', updateSize);
    }, []);
    return size;
  }

  const [width, height] = useWindowSize();

  useEffect(() => {
    if (overSeers) {
      const grouped = Map.groupBy(overSeers, x => {
        return x.name;
      });
      
      setOverSeerGroups(Object.fromEntries(grouped.entries()));
    }
    if (searchParams.get("id")) {
      setSelectedOverSeerGroup(overSeers.find(x => x.Id === searchParams.get("id")).name);
    }
  }, [overSeers]);

  useEffect(() => {
    WebHelper.get("overseers/slim", (e) => setOverSeers(e), setError => setError("Nie udało się pobrać psychologów"));
    WebHelper.get("exceptions", setExceptions, () => setError("Nie udało się pobrać wyjątków"));
  }, []);

  useEffect(() => {
    if (selectedOverSeer && selectedOverSeer !== "Wybierz") {

      WebHelper.get("reservations/slim/" + selectedOverSeer, setReservations, () => setError("Nie udało się pobrać rezerwacji"));
      let calendars = [];

      for (let i = 0; i < 12; i++) {
        calendars.push(moment().add(i * 7 + 1, 'days'));
      }
      setSelectedDate(moment().format('yyyy-MM-DD'));
      setCalendars(calendars);
      let overseer = overSeers.find(x => x.Id === selectedOverSeer);
      let hours = JSON.parse(overseer.workHours);
      setWorkHours(hours);
    }
  }, [selectedOverSeer]);

  if (!overSeers || !exceptions) {
    return (<div>loading ...</div>); //Make prettier loading
  }

  const inputClass = selectedOverSeer ? 'input-enabled' : 'input-disabled';

  const isTaken = (date, time) => {
    return reservations?.some(x => x.startTime.split(' ')[0] === date && x.startTime.split(' ')[1] === time + ":00");
  }

  const HandleSubmit = () => {

    let phoneMatch = phoneNumber?.match(/^\+?[0-9]{3}[ -]?[0-9]{3}[ -]?[0-9]{3}$/);
    let emailMatch = email?.match(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);

    let validObj = {
      "selectedOverSeer": selectedOverSeer && selectedOverSeer !== "Wybierz",
      "selectedDate": selectedDate,
      "selectedTime": selectedTime && selectedTime !== "Wybierz",
      "name": name,
      "telNumber": phoneNumber && phoneMatch,
      "email": email && emailMatch
    };

    setValidObj(validObj);
    console.log(validObj);

    if (phoneNumber && !phoneMatch) {
      setError("Proszę podać poprawny numer telefonu");
      return;
    }

    if (emailMatch && !emailMatch) {
      setError("Proszę podać poprawny adres email");
      return;
    }

    if (!Object.values(validObj).every(x => x)) {
      setError("Proszę wypełnić wszystkie pola");
      return;
    }

    let reservation = {
      startTime: selectedDate + " " + selectedTime + ":00",
      name: name,
      reason: searchParams.get("reason") || "Konsultacja",
      description: description,
      overseer: selectedOverSeer,
      telNumber: phoneNumber,
      email: email
    }

    WebHelper.post("reservations", reservation, () => {
      window.location.href = "/reservation-success";
    }, () => setError("Nie udało się zarezerwować terminu"));
  }
  let preparedWorkHours = [];
  if (selectedDate) {
    preparedWorkHours = workHours[moment(selectedDate, 'yyyy-MM-DD').day()];
    var exception = exceptions.find(x => x.Date === selectedDate);
    if (exception) {
      preparedWorkHours = JSON.parse(exception.workHours);
    }
  }

  moment.locale('pl');

  return (
    <div style={
      {
        width: '100%',
        justifyContent: 'center',
        flexWrap: 'wrap',
        display: 'flex',
      }}>
      <div className='reservationCalendars' style={{ width: '100%', display: width > 750 ? 'block' : 'none' }}>
        {selectedOverSeer && workHours ?
          <><Slide
            key={selectedOverSeer}
            autoplay={false}
            easing="cubic"
            slidesToScroll={1}
            slidesToShow={1}
            nextArrow={<FaArrowRight title='Wstecz' className='reservationArrowRight' size={'30px'} />}
            prevArrow={<FaArrowLeft title='Dalej' className='reservationArrowLeft' size={'30px'} />}
          >
            {calendars.map(x =>
            (<div key={x.format('YYYY-MM-DD')} className="each-slide-effect" style={{ textAlign: 'center' }}>
              {<Calendar overSeer={selectedOverSeer}
                exceptions={exceptions}
                reservations={reservations}
                workHours={workHours}
                startDate={x}
                selectedDate={selectedDate}
                selectedTime={selectedTime}
                setSelectedDate={(e) => { setSelectedDate(e); setValidObj({ ...validObj, selectedDate: true }) }}
                setSelectedTime={(e) => { setSelectedTime(e); setValidObj({ ...validObj, selectedDate: true }) }} />}
            </div>)
            )}
          </Slide>
            <div className='reservationLegend'>
              <div style={{ display: 'flex', margin: '5px' }}><div className='reservation-cell' style={{ width: '50px', height: '25px' }}></div> - Wolny termin</div>
              <div style={{ display: 'flex', margin: '5px' }}><div className='reservation-cell-disabled' style={{ width: '50px', height: '25px' }}></div> - Zajęty termin</div>
              <div style={{ display: 'flex', margin: '5px' }}><div className='reservation-cell-selected' style={{ width: '50px', height: '25px' }}></div> - Wybrany termin</div>
            </div>
          </>
          : <div style={{ width: '100%', heigth: '100%', textAlign: 'center', justifyContent: "center", justifyItems: "center" }}><p>Proszę wybierz specjalistę aby wyświetlić terminy.</p></div>}
      </div>
      <div className='reservationFieldset'>
        <form style={{ flexDirection: 'column', display: 'flex', width: '300px', padding: '5px' }}>

          <label>Psycholog: </label>
          <select className={validObj.selectedOverSeer + (validObj?.selectedOverSeer ? "" : " invalid")} onChange={(e) => { 
            setSelectedOverSeerGroup(overSeerGroups[e.target.value]);  
            if(overSeerGroups[e.target.value].length > 0) {
              setSelectedOverSeer(overSeerGroups[e.target.value][0].Id);
            }
            else
            {
              setSelectedOverSeer(undefined);
            }
            setValidObj({ ...validObj, selectedOverSeer: true }) }}>
            <option disabled selected value>Wybierz</option>
            {Object.keys(overSeerGroups).map(x => (<option selected={selectedOverSeerGroup === x} value={x}>{x}</option>))}
          </select>

          <label>Gabinet: </label>
          <select onChange={(e) => { setSelectedOverSeer(e.target.value); setValidObj({ ...validObj, selectedOverSeer: true }) }}>
            {!selectedOverSeerGroup ?
            (<option disabled selected value>Wybierz najpierw specjalistę</option>) :
            selectedOverSeerGroup?.map(x => (<option selected={selectedOverSeer === x.Id} value={x.Id}>{x.location}</option>))}
          </select>


          <label className={`reservationLabel ${inputClass}`}>Data: </label>
          <input className={`reservationInput ${inputClass} ${validObj?.selectedDate ? "" : " invalid"}`} type="date" value={selectedDate} onChange={(e) => { setSelectedDate(e.target.value); setValidObj({ ...validObj, selectedDate: true }) }} />

          <label className={`reservationLabel ${inputClass}`}>Godzina: </label>
          <select className={`reservationInput ${inputClass}${validObj?.selectedTime ? "" : " invalid"}`} key={selectedDate} onChange={(e) => { setSelectedTime(e.target.value); setValidObj({ ...validObj, selectedTime: true }); }} value={selectedTime}>
            <option disabled selected value>Wybierz</option>
            {preparedWorkHours && preparedWorkHours.filter(x => !isTaken(selectedDate, x)).map(x => (<option value={x}>{x}</option>))}
          </select>
          <label className={`reservationLabel ${inputClass}`}>Imię i nazwisko: </label>
          <input className={`reservationInput ${inputClass}${validObj?.name ? "" : " invalid"}`} type="text" placeholder="Imię i nazwisko" value={name} onChange={(e) => { setName(e.target.value); setValidObj({ ...validObj, name: true }); }} />

          <label className={`reservationLabel ${inputClass}`}>Numer Telefonu: </label>
          <input className={`reservationInput ${inputClass}${validObj?.telNumber ? "" : " invalid"}`} type="text" placeholder="Numer Telefonu" value={phoneNumber} onChange={(e) => { setPhoneNumber(e.target.value); setValidObj({ ...validObj, telNumber: true }) }} />

          <label className={`reservationLabel ${inputClass}`}>Email: </label>
          <input className={`reservationInput ${inputClass}${validObj?.email ? "" : " invalid"}`} type="text" placeholder="Email" value={email} onChange={(e) => { setEmail(e.target.value); setValidObj({ ...validObj, email: true }) }} />

          <label className={`reservationLabel ${inputClass}`}>Opis: </label>
          <textarea className={`reservationInput ${inputClass}`} type="text" placeholder="Opis" value={description} onChange={(e) => setDescription(e.target.value)} />

          <button className='reservationSubmit' onClick={(e) => { e.preventDefault(); HandleSubmit(); }}> Zarezerwuj </button>
          {error ? <p className='error'> {error} </p> : <></>}
        </form>
      </div>
    </div>
  );
}

export default App;
